import { useLanguage } from "./LanguageContext";
import React, { useEffect } from "react";
import "./index.css";
const LoginPage = React.lazy(() => import("./Pages/LoginPage/LoginPage"));
// import LoginPage from "./Pages/LoginPage/LoginPage";
import TagManager from "@sooro-io/react-gtm-module";

const tagManagerArgs = {
  gtmId: "GTM-5XK3HDJG",
};

TagManager.initialize(tagManagerArgs);

function App() {
  const { t } = useLanguage();
  useEffect(() => {
    document.title = t("Mental Health Connections");

    // console.log("DataLayer contents:", window.dataLayer);

    // Send a test event for gtm
    TagManager.dataLayer({
      dataLayer: {
        event: "test_event",
        testValue: "This is a test",
      },
    });
  }, []);

  return (
    <div className="App h-screen">
      <LoginPage />
    </div>
  );
}

export default App;
